export const UserInfoModel = Symbol.for('UserInfoModel');
